export var CommandID;
(function (CommandID) {
    CommandID["Upload"] = "upload";
    CommandID["MirrorLocal"] = "mirror-local";
    CommandID["Download"] = "download";
    CommandID["MirrorRemote"] = "mirror-remote";
    CommandID["Delete"] = "delete";
    CommandID["SelectAll"] = "select-all";
    CommandID["SelectAllFiles"] = "select-all-files";
    CommandID["NewDir"] = "new-dir";
    CommandID["NewFile"] = "new-file";
    CommandID["Settings"] = "settings";
    CommandID["Connections"] = "connections";
    CommandID["Refresh"] = "refresh";
    CommandID["CollapseAll"] = "collapse-all";
    CommandID["ShowFilter"] = "show-filter";
    CommandID["GoBack"] = "go-back";
    CommandID["GoForward"] = "go-forward";
    CommandID["GoUp"] = "go-up";
    CommandID["SyncBrowsing"] = "sync-browsing";
    CommandID["MirrorSync"] = "mirror-sync";
    CommandID["Rename"] = "rename";
    CommandID["Duplicate"] = "duplicate";
    CommandID["ClearContents"] = "clear-contents";
    CommandID["Edit"] = "edit";
    CommandID["CopyURI"] = "copy-uri";
    CommandID["CopyPath"] = "copy-path";
    CommandID["CopyRelativePath"] = "copy-relative-path";
    CommandID["CopyName"] = "copy-name";
    CommandID["CopyNameNoExt"] = "copy-name-no-ext";
    CommandID["Paste"] = "paste";
    CommandID["Copy"] = "copy";
    CommandID["TriggerCopy"] = "trigger-copy";
    CommandID["TriggerPaste"] = "trigger-paste";
})(CommandID || (CommandID = {}));
